"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("../HOC/Portal"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _misc = _interopRequireDefault(require("../tokens/misc"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tooltipTokens = require("../tokens/tooltipTokens");
var _TooltipUtil = require("./TooltipUtil");
var _uniqueIdHelper = _interopRequireDefault(require("../helpers/uniqueIdHelper"));
var _excluded = ["label"];
/* eslint-disable indent */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Tooltip = function Tooltip(props) {
  // eslint-disable-next-line react/prop-types
  var label = props.label,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var children = rest.children,
    size = rest.size,
    appearance = rest.appearance,
    isVisible = rest.isVisible;
  var isLabelString = typeof label === "string";
  var _useState = (0, _react.useState)(isVisible),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var id = (0, _uniqueIdHelper["default"])("tooltip");
  var tooltipContainerRef = (0, _react.useRef)();
  var tooltipRef = (0, _react.useRef)();
  var showToolTip = function showToolTip() {
    setVisible(true);
  };
  var hideToolTip = function hideToolTip() {
    setVisible(false);
  };
  var handleKeyDown = function handleKeyDown() {
    /* this overrides isVisible as well */
    if (event.key === "Escape") setVisible(false);
  };
  var child;
  if (_react["default"].Children.count(children) === 1 && /*#__PURE__*/_react["default"].isValidElement(children)) {
    /* If there's just one child which is a React Element */
    child = /*#__PURE__*/_react["default"].cloneElement(children, {
      "aria-describedby": id
    });
  } else {
    child = children;
  }
  if (isLabelString && label.length === 0) {
    //do not show any tooltip if there is no label
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
  var variant = _tooltipTokens.variants[size];
  var appearanceConfig = _tooltipTokens.appearanceConfigs[appearance];
  var labelData = isLabelString ? label : label();
  return /*#__PURE__*/_react["default"].createElement(Tooltip.container, {
    onMouseEnter: showToolTip,
    onMouseLeave: hideToolTip,
    onFocus: showToolTip,
    onBlur: hideToolTip,
    onKeyDown: handleKeyDown,
    tabIndex: 0,
    role: "tooltip",
    id: id,
    ref: tooltipContainerRef
  }, child, /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, labelData && /*#__PURE__*/_react["default"].createElement(Tooltip.Ele, (0, _extends2["default"])({}, rest, {
    variant: variant,
    appearanceConfig: appearanceConfig,
    tooltipContainerRef: tooltipContainerRef,
    tooltipRef: tooltipRef,
    role: "tooltip",
    ref: tooltipRef,
    visible: visible
  }), labelData)));
};
Tooltip.container = _styledComponents["default"].div.withConfig({
  componentId: "sc-iyc8of-0"
})(["position:relative;display:inline-block;padding:0;cursor:pointer;width:max-content;"]);
Tooltip.Ele = _styledComponents["default"].span.withConfig({
  componentId: "sc-iyc8of-1"
})(["visibility:", ";position:fixed;top:", ";left:", ";width:", ";height:", ";background-color:", ";color:", ";text-align:center;padding:", ";border-radius:", "rem;z-index:21;border-width:0.2rem;border-style:solid;border-color:", ";transition:opacity ", ";opacity:1;:after{content:\"\";position:absolute;top:", ";left:", ";right:", ";background-color:", ";width:", "px;height:", "px;transform:rotate(-45deg);box-sizing:border-box;border-style:solid;border-width:2px;border-color:", ";@media (max-width:768px){top:", ";left:", ";right:", ";border-color:", ";}}", ""], function (props) {
  return props.visible ? "visible" : "hidden";
}, (0, _TooltipUtil.getAttr)("tooltipTop"), (0, _TooltipUtil.getAttr)("tooltipLeft"), function (props) {
  return props.widthMaxContent ? "max-content" : "".concat(props.width || (0, _TooltipUtil.getAttr)("minWidth"), "rem");
}, (0, _TooltipUtil.getAttr)("minHeight") ? (0, _TooltipUtil.getAttr)("minHeight") + "px" : "auto", (0, _TooltipUtil.getAttr)("bgColor"), (0, _TooltipUtil.getAttr)("color"), (0, _TooltipUtil.getAttr)("padding"), (0, _TooltipUtil.getAttr)("borderRadius"), (0, _TooltipUtil.getAttr)("borderColor"), _misc["default"].animationDuration, (0, _TooltipUtil.getAttr)("arrowTop"), (0, _TooltipUtil.getAttr)("arrowLeft"), (0, _TooltipUtil.getAttr)("arrowRight"), (0, _TooltipUtil.getAttr)("bgColor"), (0, _TooltipUtil.getAttr)("arrowSize"), (0, _TooltipUtil.getAttr)("arrowSize"), (0, _TooltipUtil.getAttr)("arrowBorderColor"), (0, _TooltipUtil.getAttr)("arrowMobileTop"), (0, _TooltipUtil.getAttr)("arrowMobileLeft"), (0, _TooltipUtil.getAttr)("arrowMobileRight"), (0, _TooltipUtil.getAttr)("arrowMobileBorderColor"), function (props) {
  switch (props.position) {
    case "top":
      return (0, _styledComponents.css)(["margin-left:", ";@media (max-width:768px){margin-left:", ";}"], (0, _TooltipUtil.getAttr)("tooltipMarginLeft"), (0, _TooltipUtil.getAttr)("tooltipMarginLeft"));
    case "left":
      return (0, _styledComponents.css)(["@media (max-width:768px){margin-left:", ";top:", ";left:", ";}"], (0, _TooltipUtil.getAttr)("tooltipMarginLeft"), (0, _TooltipUtil.getAttr)("tooltipMobileTop"), (0, _TooltipUtil.getAttr)("tooltipMobileLeft"));
    case "bottom":
      return (0, _styledComponents.css)(["margin-left:", ";", ""], (0, _TooltipUtil.getAttr)("tooltipMarginLeft"), "" /* top:'unset'; */);
    case "bottomRight":
      return (0, _styledComponents.css)(["margin-left:", ";", ""], (0, _TooltipUtil.getAttr)("tooltipMarginLeft"), "" /* top:'unset'; */);
    case "right":
      return (0, _styledComponents.css)(["@media (max-width:768px){margin-left:", ";top:", ";left:", ";}"], (0, _TooltipUtil.getAttr)("tooltipMarginLeft"), (0, _TooltipUtil.getAttr)("tooltipMobileTop"), (0, _TooltipUtil.getAttr)("tooltipMobileLeft"));
  }
});
Tooltip.propTypes = {
  position: _propTypes["default"].oneOf(["top", "left", "bottom", "right", "bottomRight"]),
  appearance: _propTypes["default"].oneOf(["dark", "light"]),
  size: _propTypes["default"].oneOf(["small", "big"]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
  isVisible: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  widthMaxContent: _propTypes["default"].bool
};
Tooltip.defaultProps = {
  position: "top",
  appearance: "dark",
  size: "big",
  isVisible: false,
  width: 0,
  widthMaxContent: false
};
var _default = exports["default"] = Tooltip;